var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"show-arrows":false,"hide-delimiters":"","cycle":"","height":"auto"}},_vm._l((_vm.slides),function(slide,i){return _c('v-carousel-item',{key:i},[_c('img',{attrs:{"src":slide.image}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }